import { Tab } from '@mui/base/Tab'
import { TabsList } from '@mui/base/TabsList'
import { TabPanel } from '@mui/base/TabPanel'
import { Tabs as BaseTabs } from '@mui/base/Tabs'
import { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'

/**
 Pendiente: cambiar logica de tabs para que cada tab se relacione a al parametro de la url en vez de un index
 ejemplo: /administracion?tab=egresos
*/
const Tabs = ({ tabs, onTabClick, activeIndex, ...restProps }) => {
  const [activeTab, setActiveTab] = useState(0)
  const [indicatorStyle, setIndicatorStyle] = useState({})
  const tabsRef = useRef([])

  // 🔥 FIX: sincronizar activeIndex del padre con activeTab interno
  useEffect(() => {
    if (activeIndex !== undefined && activeIndex !== activeTab) {
      setActiveTab(activeIndex)
    }
  }, [activeIndex])

  const handleTabChange = (e, newValue) => {
    e?.preventDefault()
    setActiveTab(newValue)
    if (typeof onTabClick === 'function') onTabClick(newValue)
  }

  useEffect(() => {
    const currentTab = tabsRef.current[activeTab]
    if (currentTab) {
      const updateIndicator = () => {
        setIndicatorStyle({
          left: `${currentTab.offsetLeft}px`,
          width: `${currentTab.clientWidth}px`
        })
      }
      updateIndicator()
      if (typeof currentTab.scrollIntoView === 'function') {
        currentTab.scrollIntoView({
          behavior: 'smooth',
          inline: 'nearest',
          block: 'nearest'
        })
      }
      // El ancho cambia al contraer el menu y al cruzar un breakpoint.
      const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(updateIndicator) : null
      if (currentTab.parentElement) observer?.observe(currentTab.parentElement)
      observer?.observe(currentTab)
      window.addEventListener('resize', updateIndicator)
      return () => {
        observer?.disconnect()
        window.removeEventListener('resize', updateIndicator)
      }
    }
  }, [activeTab, tabs?.length])

  return (
    <>
      <BaseTabs
        value={activeTab}
        onChange={handleTabChange}
        slotProps={{ root: { className: 'w-full min-w-0 max-w-full' } }}
        defaultValue={0}
        {...restProps}
      >
        <TabsList
          slotProps={{
            root: {
              className:
                'flex relative transition-all w-full gap-x-1 sm:gap-x-2 overflow-x-auto overflow-y-hidden flex-nowrap scroll-smooth'
            }
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              ref={el => (tabsRef.current[index] = el)}
              value={index}
              slotProps={{
                root: {
                  className: clsx(
                    'transition-all pb-3 sm:pb-4 pt-1 px-3 hd:px-4 text-sm hd:text-lg whitespace-nowrap shrink-0 font-sans text-muted',
                    index === activeTab && 'font-bold text-primary'
                  )
                }
              }}
              onClick={e => handleTabChange(e, index)}
            >
              {tab.title}
            </Tab>
          ))}
          <div className='absolute bottom-0 left-0 w-full border-b-4 border-border' />
          <span
            className='absolute bottom-0 border-b-4 border-primary transition-all duration-200 rounded-full'
            style={indicatorStyle}
          />
        </TabsList>

        {tabs.map((tab, index) => (
          <TabPanel key={index} value={index} slotProps={{ root: { className: 'w-full min-w-0 max-w-full' } }}>
            {tab.content}
          </TabPanel>
        ))}
      </BaseTabs>
    </>
  )
}

export default Tabs
